import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.scss";
import FooterMenu from "./FooterMenu";
import { useLocation } from "@reach/router";
import $ from "jquery";
import axios from "axios";
import { Helmet } from "react-helmet";
import Cookies from 'universal-cookie';
import HTMLReactParser from 'html-react-parser';
import SubscribeSection from "../RightSideComponent/Sections/SubscribeSection"
import PopularSearch from "./PopularSearch";
//import StickyCta from "./StickyCta";
import StickyCtaDynamic from "./StickyCtaBtn/StickyCtaBtn";

const Footer = (props) => {

const stickySections = props?.GQLPage?.Modules?.find(
  m => m.__typename === "GLSTRAPI_ComponentModulesStickyCtaSection" ||
       m.__typename === "ComponentModulesStickyCtaSection"
)
var stickyData = stickySections ? stickySections : null;
  const cookies = new Cookies();
  const location = useLocation();
  const [active_menu, setActiveMenu] = useState(-1);
  var menu_data = props.site_menu;

  const [script_tag, setScriptTag] = useState('');
  const domainGroupId = '791e1d83-c9bc-4f2d-aa52-4b1796caf4ea';

  const clickHandler = (index) => {
    if (index === active_menu) {
      setActiveMenu(-1);
    } else {
      setActiveMenu(index);
    }

  };

  const getAvailableSlot = async url => {
    try {
      const { data } = await axios.get(url, {})
      if (data) {
        sessionStorage.setItem('avaiable_lots', JSON.stringify(data))
      }

    } catch (error) {
      //   console.error(error)
    }
  }

  useEffect(() => {
    var url = location.href;
    var gclid = null;
    var cellNumber = process.env.GATSBY_GCILD_PHONE;
    var isGCLID = 'isgclid';
    var cellElement = $(".phone_number");
    url = url.toLowerCase();
    gclid = localStorage.getItem(isGCLID);

    if (url.indexOf('gclid') != -1 || url.indexOf('gcid') != -1) {
      localStorage.setItem(isGCLID, 'true');
      gclid = true;
    }

    if (gclid && (cellNumber && cellNumber.length)) {
      cellElement.attr('href', 'tel:' + cellNumber.replace(/ /g, ''))
    }
    cellElement.show();
    if (sessionStorage.getItem('avaiable_lots') === null) {
      getAvailableSlot(`${process.env.GATSBY_STRAPI_SRC}/availablelots_ids.json`)
    }

  }, [props])


  //    var script_tag = '';
  // if(cookies?.get('cookieyes-functional') === "yes"){
  //   script_tag = ''
  // } else{
  //   script_tag = `<script defer ="true" id="cookieyes" type="text/javascript" src="https://cdn-cookieyes.com/client_data/6aeedc3026b64d2af4181ff9/script.js"></script>`;
  // }

  //console.log("menu_data", menu_data)

  var department = props.GQLPage?.select_menu && props.GQLPage?.select_menu?.Main_Parent !== null ? props.GQLPage?.select_menu?.Main_Parent.Label : props.GQLPage?.select_menu?.Label;
  var type = props.GQLPage?.select_menu && props.GQLPage?.select_menu?.Type;
  var page_url = typeof window !== "undefined" ? window.location.href : '';
  var sub_type = props.GQLPage?.select_menu && props.GQLPage?.select_menu?.Sub_Type;
  var to_user_id = props.GQLPage?.select_menu?.Form_User_ID ? props.GQLPage?.select_menu?.Form_User_ID : '';
  //console.log("Menu_Link", department)
  return (
    <React.Fragment>

      <footer className="footer" >
        <Container>
          <Row>
            <div className="footer-wrapper">
              <div className="footer-menus">
                {menu_data?.Top_Menus && menu_data?.Top_Menus.length > 0 && menu_data?.Top_Menus.map((item, i) => (
                  <FooterMenu i={i} {...item} clickHandler={clickHandler} active_menu={active_menu}/>

                ))}
              </div>
              <SubscribeSection isFooter={true} />
            </div>

            <div className="footer-bottom">
              <Col md={12}>
                <PopularSearch slug={props?.popular_search_slug} />
                {
                  props.site_config && <>

                    {/* <div className="footer-info">
                      <div className="site-links">
                        <span className="site-info">
                          {
                            props.site_config.Footer_Bottom_Links && props.site_config.Footer_Bottom_Links.length > 0 && props.site_config.Footer_Bottom_Links.map((item, index) => {
                              if (index < 3) {
                                return (
                                  <React.Fragment key={index}><Link to={`/${item.Menu_Link.Primary_URL}/`} state={{ "department": department, "page_url": location.href, "type": type, "sub_type": sub_type, "to_user_id": to_user_id }}> {item.Label}</Link>{index < 2 ? " | " : ""}</React.Fragment>
                                )
                              }

                            })
                          }
                        </span>
                      </div>
                    </div> */}



                    <div className="footer-info">
                      <div className="site-links">
                        <span className="site-info">
                          {
                            props.site_config.Footer_Bottom_Links && props.site_config.Footer_Bottom_Links.length > 0 && props.site_config.Footer_Bottom_Links.map((item, index) => {
                              if (index >= 3) {
                                return (
                                  <React.Fragment key={index}><Link to={`/${item.Menu_Link.Primary_URL}/`}> {item.Label} </Link>{index < (props.site_config.Footer_Bottom_Links.length - 1) ? " | " : ""}</React.Fragment>
                                )
                              }
                            })
                          }

                          <br />
                          Copyright &copy; Strettons {new Date().getFullYear()} All Rights Reserved
                          <br />
                          Site by
                          <Link to="https://starberry.tv/" target="_blank">
                            <svg width="88" height="18" viewBox="0 0 91 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M91 7.15338H88.9966L86.7986 15.0498C86.8027 14.9775 86.8027 14.905 86.7986 14.8327C86.7968 14.4967 86.7506 14.1624 86.6612 13.8385L84.8753 7.15338H82.8147C82.8147 7.15338 85.7797 17.0611 86.043 17.2439C85.6652 18.3867 85.2875 18.9695 84.5777 19.278L85.276 20.4208C86.3358 20.1201 87.1741 19.309 87.5084 18.261L91 7.15338ZM80.6968 6.98168C79.8422 6.93396 79.0478 7.42155 78.7049 8.20443C78.6068 7.72958 78.3169 7.31614 77.9035 7.06167L76.6213 7.82732C76.9678 8.17236 77.1616 8.64149 77.1594 9.13006V17.1294H78.9682V10.4214C78.9676 10.0071 79.1377 9.61074 79.4387 9.32544C79.7397 9.04014 80.145 8.89096 80.5594 8.91294C80.9666 8.91181 81.3649 9.0311 81.7042 9.25576L82.2766 7.49592C81.7949 7.17346 81.2309 6.99505 80.651 6.98168H80.6968ZM74.4233 6.98181C73.5678 6.93069 72.7717 7.41939 72.4314 8.20456C72.3172 7.73682 72.0312 7.32895 71.63 7.0618L70.3478 7.82745C70.6986 8.1706 70.8965 8.63997 70.8973 9.13019V17.1295H72.7176V10.4215C72.7173 10.0113 72.8843 9.61875 73.1802 9.33416C73.4761 9.04957 73.8754 8.89753 74.2859 8.91307C74.6931 8.91194 75.0915 9.03123 75.4307 9.25589L75.9803 7.49605C75.5064 7.17484 74.9501 6.99634 74.3775 6.98181H74.4233ZM65.4596 8.5932C65.8753 8.58089 66.2785 8.7364 66.578 9.02458C66.8775 9.31276 67.0479 9.70928 67.0508 10.1245V11.1073H63.6851V10.2388C63.6631 9.77866 63.8423 9.33168 64.1762 9.01373C64.5101 8.69577 64.9658 8.53817 65.4252 8.58177L65.4596 8.5932ZM65.5168 6.98173C63.4447 6.98173 61.8534 8.01022 61.8534 10.2157V13.8611C61.8101 14.8094 62.1791 15.7302 62.8657 16.387C63.5522 17.0438 64.4894 17.3728 65.4367 17.2894C66.6785 17.3103 67.8902 16.9071 68.8711 16.1466L68.1269 14.6268C67.383 15.2494 66.4526 15.6072 65.4825 15.6438C64.9696 15.6688 64.4722 15.4649 64.1249 15.0873C63.7776 14.7098 63.6165 14.1977 63.6851 13.6897V12.7069H68.894V10.4214C68.9863 9.49007 68.6579 8.5661 67.9983 7.901C67.3386 7.23591 66.4164 6.89891 65.4825 6.98173H65.5168ZM54.7443 4.06775H52.9355V15.4039C52.9417 15.8324 52.6751 16.2178 52.2715 16.3638L53.1988 17.3466C53.5997 17.25 53.9601 17.0301 54.2291 16.7181C54.9292 17.105 55.7186 17.302 56.5187 17.2895C57.4405 17.3819 58.3593 17.087 59.0544 16.4756C59.7494 15.8641 60.158 14.9914 60.182 14.0669V10.1929C60.258 9.31204 59.937 8.44313 59.3063 7.82238C58.6756 7.20162 57.8007 6.89351 56.9194 6.98178C56.1512 6.99735 55.3992 7.20563 54.7328 7.58744L54.7443 4.06775ZM56.7705 8.6388C57.1998 8.60998 57.6201 8.77095 57.92 9.07903C58.2198 9.3871 58.3688 9.81114 58.3275 10.2387V14.1583C58.3169 14.6159 58.1159 15.0485 57.7727 15.3521C57.4294 15.6557 56.9751 15.8028 56.5187 15.7582C55.8854 15.7809 55.2609 15.6051 54.7328 15.2554V9.33589C55.3236 8.86099 56.0578 8.59925 56.8163 8.59309L56.7705 8.6388ZM50.2337 6.98169C49.3775 6.93904 48.5826 7.42425 48.2303 8.20444C48.1363 7.73102 47.8505 7.31745 47.4404 7.06168L46.1697 7.82733C46.513 8.17449 46.7062 8.64225 46.7078 9.13007V17.1294H48.528V10.4214C48.527 10.0029 48.7003 9.60272 49.0064 9.31669C49.3125 9.03065 49.7239 8.88441 50.1422 8.91295C50.5493 8.91182 50.9477 9.03111 51.287 9.25578L51.8365 7.49593C51.3626 7.17472 50.8063 6.99622 50.2337 6.98169ZM40.9609 6.98186C39.6425 6.90616 38.367 7.46217 37.5265 8.47888L38.4996 9.70163C39.0275 8.9674 39.8839 8.53994 40.7892 8.55887C41.2272 8.51936 41.6601 8.67681 41.97 8.98837C42.2799 9.29993 42.4346 9.73317 42.3919 10.1702V11.1301H40.6518C39.7521 11.0531 38.8614 11.3571 38.1973 11.9678C37.5332 12.5786 37.1568 13.4399 37.1601 14.3412C37.158 14.7326 37.2319 15.1207 37.3777 15.484C37.9067 16.7138 39.1674 17.4652 40.503 17.3467C41.3219 17.3459 42.121 17.0946 42.7925 16.6267C43.0619 16.9784 43.4278 17.2444 43.8458 17.3924L44.8875 16.5239C44.5137 16.1979 44.2834 15.7381 44.2464 15.244V10.273C44.3078 9.38479 43.9818 8.51342 43.3522 7.88277C42.7227 7.25213 41.8509 6.9237 40.9609 6.98186ZM42.4377 12.6957V15.0383C41.9418 15.4471 41.3282 15.6873 40.6861 15.724C40.4999 15.7257 40.3146 15.6987 40.1366 15.644C39.5018 15.4805 39.0617 14.9042 39.072 14.2498C39.0896 13.8161 39.2817 13.4078 39.605 13.1174C39.9282 12.827 40.3552 12.6791 40.7892 12.7071L42.4377 12.6957ZM33.9204 4.15912L32.0658 4.90191V7.18743H30.7378V8.67301H32.0543V15.0267C32.0543 16.8323 33.0389 17.3123 33.9204 17.3123C34.649 17.3589 35.3673 17.1213 35.9238 16.6495L35.4429 15.1182C35.2143 15.4 34.8782 15.574 34.5157 15.5981C34.3453 15.6096 34.1787 15.5446 34.0613 15.4208C33.9439 15.297 33.888 15.1274 33.9089 14.9582V8.67301H36.0611L36.3473 7.15315H33.9204V4.15912ZM26.1586 3.87353C23.8118 3.87353 22.2091 5.26769 22.2091 7.23323C22.2801 8.86455 23.3214 10.2954 24.8536 10.8672C25.8018 11.248 26.677 11.7892 27.4408 12.4671C27.7494 12.8081 27.9172 13.2532 27.9102 13.7127C27.9091 14.2703 27.6721 14.8015 27.2576 15.1754C26.7612 15.5194 26.1674 15.6956 25.5633 15.6782C24.5734 15.6394 23.6339 15.2317 22.9303 14.5355L21.8427 15.9068C22.8298 16.9007 24.1983 17.4214 25.5977 17.3352C27.3796 17.4881 29.0473 16.4436 29.6846 14.7754C29.7921 14.4471 29.8462 14.1038 29.8449 13.7584C29.8435 13.1809 29.7021 12.6124 29.4328 12.1014C29.0007 11.3093 28.3488 10.6586 27.5553 10.2273C26.4105 9.5416 24.1209 8.83309 24.1209 7.27894C24.1307 6.79053 24.3461 6.32882 24.7142 6.00698C25.0824 5.68514 25.5693 5.53293 26.0556 5.58766C26.9529 5.5736 27.811 5.95385 28.4024 6.62757L29.4786 5.3134C28.6314 4.37177 27.4148 3.84594 26.1472 3.87353H26.1586ZM14.516 4.5706L14.31 4.86772C14.2505 4.95622 14.215 5.05858 14.2069 5.16484C14.2173 5.27259 14.271 5.37155 14.3558 5.4391C14.7239 5.75625 15.1467 6.00406 15.6036 6.17046L15.9928 6.33045C15.5987 5.6683 15.1 5.07403 14.516 4.5706ZM9.93685 2.78794C10.4527 3.13592 11.039 3.36612 11.654 3.46216H11.8601C12.0515 3.46415 12.239 3.40839 12.3982 3.30218C11.6178 3.00286 10.7947 2.82928 9.95974 2.78794H9.93685ZM8.73481 3.03941C8.67445 3.07279 8.63239 3.13157 8.62033 3.19939C8.62033 3.39366 8.88363 3.61078 8.88363 3.61078C9.08389 3.7673 9.21196 3.99823 9.23852 4.25073C9.23852 4.63927 8.86074 5.11922 7.33816 5.49633C7.33816 5.49633 5.71254 5.80488 5.71254 6.36483C5.71254 6.60481 5.90716 6.6848 6.19336 6.6848C6.52252 6.6912 6.85168 6.6721 7.17788 6.62766C7.55246 6.53265 7.93637 6.479 8.32268 6.46768C9.18128 6.46768 10.1887 6.87907 10.3833 8.91318C10.3833 8.91318 10.4635 10.6273 10.8069 10.7302C11.1503 10.833 11.1847 10.0331 11.4136 9.09602C11.5739 8.36465 12.2035 6.98192 13.5773 6.98192C14.0207 6.9942 14.4553 7.10756 14.848 7.31332C15.3264 7.59858 15.8485 7.80321 16.3935 7.91898C16.4965 7.91898 16.5767 7.91898 16.611 7.81613C16.6454 7.71328 16.84 7.33617 15.3403 6.67337C14.2985 6.2277 13.5201 5.7706 13.5201 5.11922C13.542 4.82181 13.6629 4.54024 13.8635 4.31929C13.986 4.18696 14.0623 4.01857 14.081 3.83934C14.0863 3.76978 14.066 3.70067 14.0238 3.64507C13.9554 3.55814 13.848 3.51099 13.7376 3.51936C13.3987 3.57431 13.0773 3.70734 12.7988 3.9079C12.5282 4.07526 12.2123 4.15508 11.8945 4.13645C11.0599 4.08888 10.2604 3.7856 9.60486 3.26796C9.43156 3.12678 9.22062 3.03938 8.99811 3.01655C8.90987 3.00064 8.81897 3.00853 8.73481 3.03941ZM7.77318 3.03939C4.3961 3.71546 1.92729 6.61978 1.80878 10.0559C1.81179 10.3926 1.83857 10.7286 1.88892 11.0616C2.51673 14.6045 5.64688 17.1556 9.24997 17.061C9.6599 17.0588 10.0692 17.0283 10.4749 16.9696C14.1269 16.5158 16.9048 13.4763 17.0231 9.80452C17.0204 9.47163 16.9936 9.13937 16.943 8.81032V8.66176C16.8448 8.68146 16.7436 8.68146 16.6454 8.66176C15.8806 8.57588 15.1389 8.34716 14.4588 7.98753C14.1807 7.85079 13.8758 7.77667 13.5659 7.77041C13.3822 7.76556 13.1995 7.79662 13.0278 7.86183C12.3791 8.35113 11.9642 9.08834 11.883 9.89594C11.8459 10.3729 11.7177 10.8384 11.5052 11.2672C11.3359 11.5047 11.0644 11.6486 10.7726 11.6558C10.497 11.651 10.2375 11.5257 10.0628 11.313C9.76032 10.6896 9.60374 10.0058 9.60486 9.31313C9.60486 9.09601 9.51327 7.86183 8.87219 7.43901C8.63872 7.30756 8.37295 7.2442 8.10517 7.25617C7.49316 7.31429 6.88529 7.4097 6.28494 7.54186H5.9415C5.45489 7.58391 4.99514 7.31314 4.7967 6.86763C4.74783 6.76822 4.72424 6.65833 4.72802 6.54766C4.73747 6.27085 4.84731 6.00689 5.03711 5.80487C5.73893 5.28879 6.55629 4.95145 7.41829 4.8221C7.72839 4.75344 8.02079 4.62112 8.27689 4.43356C8.35703 4.37642 8.39137 4.35357 8.39137 4.33071C8.39137 4.30786 8.29979 4.22786 8.12807 4.02217C7.91724 3.82898 7.78654 3.56398 7.76173 3.27937C7.76569 3.17802 7.78499 3.07785 7.81897 2.98226L7.77318 3.03939ZM11.4709 2.21656C10.8705 2.10643 10.2611 2.05286 9.65065 2.05658C8.63605 2.05309 7.62739 2.21126 6.66272 2.52511C2.83302 3.68491 0.159107 7.1383 0 11.1301C0.00167789 11.9055 0.121339 12.6761 0.354887 13.4156C1.0195 15.4395 2.47172 17.1115 4.38458 18.0552C5.76358 18.788 7.29859 19.1799 8.86074 19.1979C9.83968 19.1993 10.8129 19.049 11.7456 18.7523C15.6254 17.6116 18.317 14.0924 18.3969 10.0559C18.3986 9.31437 18.2984 8.57614 18.0993 7.86178C17.7791 6.75939 17.2069 5.74623 16.4279 4.90204C15.9075 4.3974 15.3445 3.9386 14.745 3.53073C14.7546 3.61808 14.7546 3.70622 14.745 3.79357V3.87356C15.9555 4.76437 16.8563 6.01116 17.3208 7.43896C17.5757 8.1739 17.7034 8.94677 17.6986 9.72448C17.6981 10.9535 17.3913 12.1631 16.8056 13.2442C15.7043 15.2726 13.8443 16.7843 11.6311 17.4495C10.7682 17.7216 9.86871 17.8604 8.96377 17.8609C5.52476 17.9528 2.42392 15.8059 1.30507 12.5585C1.08859 11.8709 0.980457 11.1538 0.984526 10.433C1.10228 6.80246 3.55379 3.66273 7.05196 2.66224C7.52596 2.51465 8.01269 2.41136 8.50585 2.35369H8.7577H9.65065C10.8489 2.34546 12.0365 2.57866 13.1423 3.03935L13.314 2.91365V2.79937C12.7269 2.52781 12.1075 2.33197 11.4709 2.21656Z" fill="white" />
                            </svg>
                          </Link>
                        </span>
                      </div>
                      <div className="social-links">
                        <ul className="social-icon">
                          {
                            props.site_config.Linkedin_Link &&
                            <li>
                              <a href={props.site_config.Linkedin_Link} target="_blank">
                                <i className="icon-linkedln"></i>
                              </a>
                            </li>
                          }
                          {
                            props.site_config.Instagram_Link &&
                            <li>
                              <a href={props.site_config.Instagram_Link} target="_blank">
                                <i className="icon-insta"></i>
                              </a>
                            </li>
                          }
                          {/* {
                            props.site_config.Facebook_Link &&
                            <li>
                              <a href={props.site_config.Facebook_Link} target="_blank">
                                <i className="icon-fb"></i>
                              </a>
                            </li>
                          }
                          {
                            props.site_config.Twitter_Link &&
                            <li>
                              <a href={props.site_config.Twitter_Link} target="_blank">
                                <i className="icon-twitter"></i>
                              </a>
                            </li>
                          } */}
                          <li>
                            <a href="https://www.youtube.com/channel/UCs0iWTv8dxNalyr5-wRJSJw" target="_blank" className="youtube-play">
                              <i className="icon-youtube"></i>
                            </a>
                          </li>
                        </ul>
                      </div>

                    </div>

                  </>
                }

                {props.site_config.Footer_Logo_Component && props.site_config.Footer_Logo_Component.length > 0 &&
                  <div className="our-brands">
                    {
                      props.site_config.Footer_Logo_Component.map((item, index) => {
                        return (
                          <div className={`brand-img img0${parseInt(index) + 1}`} key={index}>
                            <Link to={item.Link} target="_blank">
                              <img src={item.Image.url} alt={item.Name} width="120" height="40" loading="lazy" />
                            </Link>
                          </div>
                        )
                      })
                    }

                  </div>
                }
              </Col>
            </div>
          </Row>
        </Container>


        {/* <CookieConsent
            disableStyles={true}
            buttonClasses="btn btn-primary"
            containerClasses="cookie-popup d-lg-flex d-block"
            buttonWrapperClasses="cook_txt"
            buttonClasses="btn btn-link gotit"
            buttonText="Accept Cookies"
            contentClasses="cook_txt"
        >
            We have placed cookies on your device to help make this website better. By continuing, you agree to our <Link to="/cookies/">Cookie Policy</Link>.
        </CookieConsent> */}

        <Helmet>

          {typeof window !== "undefined" && (script_tag ? HTMLReactParser(script_tag) : "")}

        </Helmet>

        <script defer
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-10810490027');`
          }}
        />
      </footer>
      <div className="sticky-bottom-section d-block d-md-none">
        {/* <StickyCta location={location.href} department={department} page_url={page_url} type={type} sub_type={sub_type} to_user_id={to_user_id} popup_form={true} page={props.GQLPage} /> */}
        {props?.GQLPage?.Show_Sticky_Btn &&
          <StickyCtaDynamic location={location.href} department={department} page_url={page_url} type={type} sub_type={sub_type} to_user_id={to_user_id} popup_form={true} page={props.GQLPage} sticky_data={stickyData} show_sticky={props.GQLPage.Show_Sticky_Btn} />}
      </div>
    </React.Fragment>
  );
};
export default Footer;
